import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { getHref } from 'src/utils/getHref';
import { ROUTES } from 'src/constants/routes.const';
import { LanguagePairLink } from 'src/types/link';
import { useTargetLanguagesContext } from 'src/context/targetLanguages';
import { tryGetTargetMessages, getTargetMessages } from 'src/utils/getTargetMessages';
import * as localesWithMessages from './messages';

export const useCoursesLinks = (): LanguagePairLink[] => {
  const intl = useIntl();
  const targetLanguages = useTargetLanguagesContext();

  return useMemo(
    () =>
      targetLanguages
        .filter(
          ({ targetLanguageLocale }) =>
            !!tryGetTargetMessages(localesWithMessages, targetLanguageLocale),
        )
        .map(({ sourceLanguageLocale, targetLanguageLocale, targetLanguageImage }) => {
          const msgs = getTargetMessages(localesWithMessages, targetLanguageLocale);

          return {
            text: intl.formatMessage(msgs.course),
            href: getHref({
              pathname: ROUTES.course,
              query: {
                sourceLanguageLocale,
                targetLanguageLocale,
              },
            }),
            image: { externalSrc: targetLanguageImage },
          };
        })
        .sort((a, b) => a.href.localeCompare(b.href)),
    [intl, targetLanguages],
  );
};
